import React, { useEffect } from 'react';

import './user-details.scss';
import { getUserDetails } from '../../redux/actions/ManagerAction';
import { connect } from 'react-redux';
import { Loader } from '../../components';
import useToaster from '../../components/Toaster/useToaster';
import QuestionAnswer from '../QuetionAnswer';

const UserDetails = ({
  match: {
    params: { id },
  },
  getUserDetails,
  useDetails: {
    error,
    loading,
    details: {
      first_name,
      last_name,
      email,
      company_anniversary,
      profile_questions,
    } = {},
  },
}) => {
  const { toast } = useToaster();

  useEffect(() => {
    getUserDetails(id);
  }, []);

  useEffect(() => {
    if (error) {
      toast({
        text: error,
        type: 'error',
      });
    }
  }, [error]);

  if (loading) return <Loader isAbsolute />;

  return (
    <div className="user-details-wrapper">
      {first_name && (
        <div className=" userdetail-info">
          <div className="user-detail-label">First Name:</div>
          <div className="user-detail-value">{first_name}</div>
        </div>
      )}
      {last_name && (
        <div className="userdetail-info">
          <div className="user-detail-label">Last Name:</div>
          <div className="user-detail-value">{last_name}</div>
        </div>
      )}
      {email && (
        <div className="userdetail-info">
          <div className="user-detail-label">Email:</div>
          <div className="user-detail-value">{email}</div>
        </div>
      )}
      {company_anniversary && (
        <div className="userdetail-info">
          <div className="user-detail-label">Company Start Date:</div>
          <div className="user-detail-value">{company_anniversary}</div>
        </div>
      )}
      {profile_questions && (
        <QuestionAnswer profile_questions={profile_questions} />
      )}
    </div>
  );
};

const mapStateToProps = (state) => ({
  useDetails: state.manager.useDetails,
});

const mapDispatchToProps = (dispatch) => ({
  getUserDetails: (payload) => {
    dispatch(getUserDetails(payload));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(UserDetails);
